import { Provider } from '@rollbar/react';
import type { ReactNode } from 'react';

import { rollbarConfig } from '@/config/rollbar.config';

export function RollbarProvider({ children }: { children: ReactNode }) {
  return <Provider config={rollbarConfig}>{children}</Provider>;
}
